import { render, staticRenderFns } from "./RiwayatTambahProduct.vue?vue&type=template&id=9ddb6a32&scoped=true&"
import script from "./RiwayatTambahProduct.vue?vue&type=script&lang=js&"
export * from "./RiwayatTambahProduct.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatTambahProduct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RiwayatTambahProduct.vue?vue&type=style&index=1&id=9ddb6a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddb6a32",
  null
  
)

export default component.exports